import { keepPreviousData, useQuery, useMutation } from '@tanstack/react-query';
import { queryClient } from '@/shared/services/queryClient';
import {
  rolesApi,
} from '../services/roleApi';
import type {  CreateRoleRequest,
  AssignPermissionsRequest,
} from '../services/roleApi';

export const useRoles = (pageNumber: number, pageSize: number, search?: string) => {
  return useQuery({
    queryKey: ['roles', pageNumber, pageSize, search],
    queryFn: () => rolesApi.getAllRoles(pageNumber, pageSize, search),
    placeholderData: keepPreviousData,
  });
};

export const useRoleById = (id: string) => {
  return useQuery({
    queryKey: ['roles', id],
    queryFn: () => rolesApi.getRoleById(id),
  });
};

export const useAvailablePermissions = () => {
  return useQuery({
    queryKey: ['permissions'],
    queryFn: rolesApi.getAvailablePermissions,
  });
};

export const useCreateRole = () => {
  return useMutation({
    mutationFn: (payload: CreateRoleRequest) => rolesApi.createRole(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] });
    },
  });
};

export const useAssignPermissions = (roleId: string) => {
  return useMutation({
    mutationFn: (payload: AssignPermissionsRequest) =>
      rolesApi.assignPermissions(roleId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] });
      queryClient.invalidateQueries({ queryKey: ['roles', roleId] });
    },
  });
};

export const useDeleteRole = () => {
  return useMutation({
    mutationFn: (id: string) => rolesApi.deleteRole(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] });
    },
  });
};